export default __webpack_public_path__ + "static/media/maize.3d55e6f5.jpg";